import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAlert,_vm._g(_vm._b({},'v-alert',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"alertMessage"},[_vm._v(_vm._s(_vm.textAlert))])])
}
var staticRenderFns = []

export { render, staticRenderFns }